import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import GroupDeleteModal from './GroupDeleteModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.groupDeleteModal.status,
  id: state.modal.groupDeleteModal.id,
  table: state.user.table
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_GROUP_DELETE, { status: false, id: null }),
  deleteGroup: actions.group.deleteGroup,
  getUsers: actions.user.getUsers,
  updateTable: actions.user.updateTable
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupDeleteModal)



// WEBPACK FOOTER //
// ./src/components/Modals/GroupDeleteModal/index.js